module.exports = __webpack_public_path__ + "img/banner_3.1fe71efb.jpg";